import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconNook12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconNook12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Nook12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M10.889 8.437a.25.25 0 0 1 .111.208v.665L6.5 6.887V1.742l.575.359a.25.25 0 0 1 .117.212v1.258c0 .454.246.873.643 1.093l1.133.63a.25.25 0 0 1 .128.218v1.061c0 .418.209.808.557 1.04zm-5.39-1.55L1 9.312v-.666a.25.25 0 0 1 .112-.208l1.236-.824a1.25 1.25 0 0 0 .557-1.04V5.512a.25.25 0 0 1 .128-.219l1.133-.629a1.25 1.25 0 0 0 .643-1.093V2.313a.25.25 0 0 1 .117-.212l.575-.36zm-3.957 3.268L6 7.754l4.458 2.4-.759.422a.25.25 0 0 1-.233.005l-1.022-.51a1.25 1.25 0 0 0-1.067-.025l-1.276.567a.25.25 0 0 1-.203 0l-1.275-.567a1.25 1.25 0 0 0-1.067.024l-1.022.511a.25.25 0 0 1-.233-.005zm10.189.436-1.546.86c-.36.2-.797.21-1.166.024l-1.022-.51a.25.25 0 0 0-.214-.005l-1.275.567a1.25 1.25 0 0 1-1.016 0l-1.276-.567a.25.25 0 0 0-.213.005l-1.022.51a1.25 1.25 0 0 1-1.166-.025l-1.558-.865L0 10.442V8.645c0-.418.209-.808.556-1.04l1.236-.824a.25.25 0 0 0 .112-.208V5.512c0-.454.246-.872.643-1.093l1.132-.629a.25.25 0 0 0 .129-.219V2.313c0-.431.222-.832.587-1.06l1.34-.837L6 .25l.265.166 1.34.837c.365.228.587.629.587 1.06v1.258c0 .091.05.175.129.219l1.132.63c.397.22.643.638.643 1.092v1.061a.25.25 0 0 0 .111.208l1.236.824c.348.232.557.622.557 1.04v1.797l-.244.135z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Nook12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconNook12);
